@if (width && height) {
  <div class="bg-gray-100 animate-pulse " [style.width]="width" [style.height]="height"
      [style.border-radius]="borderRadius"></div>
}